module.exports = __webpack_public_path__ + "static/img/mxzy2.6f87bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/mxzy2.png
// module id = 8mpA
// module chunks = 0